import React from "react";
import Header from "../../components/public/Header";
import Footer from "../../components/public/Footer";

export const TermsAndCondition = () => {
  return (
    <>
      <Header />
      <div className="max-w-[1280px] mx-auto mt-1 text-left">
        <div className="my-10">
          <h3 className="text-[#2f5496] font-bold text-f18 md:text-f32">Terms and Conditions</h3>
        </div>
        <div className="my-5 flex text-start	 flex-col">
          <div className="font-bold text-[20px]">1 - Agreement</div>
          <div>
            1.1 - TREVEX Technology Limited, is a company registered in Dubai
            International Financial Centre under company registration number 5069,
            having its registered office at Unit GA-00-SZ-L1-RT-201, Level 1, Gate
            Avenue – South Zone, Dubai International Financial Centre, Dubai,
            United Arab Emirates (“Trevex”, “we”, “us”, “our”).
          </div>
          <div>
            1.2 - Trevex owns and operates the internet website https://trevex.io,
            and any of its content (“Site”). By accessing and using the Site, you
            are expressly consenting to these Terms and Conditions of Use that are
            effective as of the date and time you use or access the Site (the
            'Terms'). Please read these Terms carefully before accessing or using
            the information and services available through this Site.
          </div>
          <div>
            1.3 - These Terms will constitute a legal agreement between you, the
            user of the Site, (“you”, “your”) and Trevex. If you do not agree to,
            or cannot comply with, the Terms, please kindly refrain from using the
            Site.
          </div>
          <div>
            1.4 - These Terms may be modified or revised at any time without
            notice. By using this Site or otherwise indicating your consent you
            are agreeing to be bound by the then current version of the Terms. If
            you do not agree with any of the Terms or any change to the Terms,
            then you must immediately stop using the Site.
          </div>
          <div>
            1.5 - Advertisers providing content for the Site are also subject to
            additional terms and conditions as below. Advertisers providing
            content for the Site agree to be bound by these Terms.
          </div>
          <div>
            1.6 - These Terms apply to any part of the Site, its functionality and
            Content and is provided to you for information and record purposes
            only.
          </div>
          <div>
            1.7 - If you order any products, services or digital content from the
            Site on a pay-as-you-go basis, or if you buy a standard subscription
            to access enhanced features of the Site, these Terms will continue to
            apply. These Terms will also apply if you opt for the company profile
            registration and verification option.
          </div>
        </div>
        <div className="my-5 flex text-start	 flex-col">
          <div className="font-bold text-[20px]">2 - The Site</div>
          <div>
            2.1 - The Site is owned and operated by Trevex for the purpose of
            providing information to users of the Site. This information consists
            of a business directory where users of the Site can access detailed
            information about businesses and the professional information of the
            individuals maintaining an official relationship with the business,
            which may include shareholders, directors, managers, employees and
            other individuals involved in the incorporation and operation of the
            business. Trevex stores and maintains this business directory and
            makes it available to users of the Site who wish to purchase
            information about a specific business.
          </div>
          <div>
            2.2 - This information may be provided to users of the Site on a
            pay-as-you-go basis, a susbscription basis or a one-time company
            profile registration and verification service, depending on the
            requirement of the user. Where the requirements of the user are not
            satisfied with these options, Trevex may provide personalised
            enterprise solutions tailored to individuals and corporates.
          </div>
          <div>
            2.3 - Trevex collects and maintains a database of information and
            makes this information available to other users of the Site, which may
            require registration. This information may be voluntarily provided by
            users of the Site. Trevex also collects information through various
            other methods, including online searches, conferences, events,
            individual introductions, from businesses who register with Trevex,
            and from selected third-party business information providers.
            Occasionally, Trevex may also acquire from third-parties specific
            lists with the names and contact details of businesses and individuals
            who may potentially require the services of Trevex.
          </div>
          <div>
            Users of the Site may be natural or legal persons and may have to
            register and provide payment to access enhanced features of the Site.{" "}
          </div>
        </div>
        <div className="my-5 flex text-start	 flex-col">
          <div className="font-bold text-[20px]">3 - Contact us</div>
          <div>
            3.1 - You can contact us by post, email or telephone if you have any
            questions about these Terms or to make a complaint. Our contact
            details are shown below: TREVEX Technology Ltd DIFC FinTech Hive, Gate
            Avenue Al Mustaqbal Street - Dubai United Arab Emirates
            contact@trevex.io +971 52 260 2838
          </div>
        </div>
        <div className="my-5 flex text-start	 flex-col">
          <div className="font-bold text-[20px]">4 - Use of Site</div>
          <div>
            4.1 - All information, text, materials, graphics, logos, button icons,
            images, video and audio clips, trade marks (whether registered or
            not), advertisements, layout, arrangement, graphical user interface,
            look and feel, and control features of the Site ('Content') is
            provided to you as a service to allow you and other users to browse
            the Content.
          </div>
          <div>
            4.2 - This Site is for the administration and access of business
            directory records and for the provision of business directory services
            and should be used for these purposes only.
          </div>
          <div>
            4.3 - You agree that you are solely responsible for all costs and
            expenses you may incur in relation to your use of the Site.
          </div>
          <div>
            4.4 - We make no promise that the Site is appropriate or available for
            use in locations outside of the United Arab Emirates. If you choose to
            access the Site from locations outside the United Arab Emirates, you
            acknowledge you do so at your own initiative and are responsible for
            compliance with local laws where they apply.
          </div>
          <div>
            4.5 - We try to make the Site as accessible as possible. If you have
            any difficulties using the Site, please contact us using the contact
            details given above.
          </div>
          <div>
            <div>
              4.6 - We permit you to use the Site only for accessing and
              maintaining business records. Use of the Site in any other way,
              including unacceptable use set out below, is not permitted. As a
              condition of your use of the Site, you agree not to use the Site:
            </div>
            <p>
              (a) to modify, publish, transmit, transfer, sell, reproduce, create
              derivative works from, distribute, perform, display, or in any way
              exploit any of the Content, in whole or in part, except as otherwise
              expressly permitted in these Terms;
            </p>
            <p>(b) in violation of any applicable law or regulation;</p>
            <p>
              (c) to transmit, distribute, store or destroy material or Content,
              in a manner that will infringe the copyright, trade mark, trade
              secret or other intellectual property rights of Trevex or others or
              violate the privacy, publicity or other personal rights of others;
            </p>
            <p>
              (d) to sell, modify or delete the Content or reproduce, display,
              publicly perform, distribute or otherwise use the Content in any way
              for any public or commercial purpose;
            </p>
            <p>
              (e) to access data not intended for you or logging into a server or
              account which you are not authorised to access;
            </p>
            <p>
              (f) to attempt to probe, scan or test the vulnerability of a system
              or network or to breach security or authentication measures without
              proper authorisation;
            </p>
            <p>
              (g) to copy or adapt the code created to generate any Content or the
              pages making up the Site;
            </p>
            <p>
              (h) to use the Content to impersonate or otherwise misrepresent your
              identity or affiliation with Trevex or any other person or entity;
            </p>
            <p>
              (i) to use the Content to send unsolicited mail or email, make
              unsolicited phone calls or send unsolicited faxes regarding
              promotions and/or advertise of products or services;
            </p>
            <p>
              (j) use any device, software or routine to interfere or attempt to
              interfere with the proper working of the Site or any activity being
              conducted on the Site, including without limitation, material that
              contains viruses, trojan horses or other computer programming
              routines or engines that are intended to damage, detrimentally
              interfere with, surreptitiously intercept or expropriate any system,
              data or information; or
            </p>
            <p>
              (k) attempt to decipher, decompile, disassemble or reverse engineer
              any of the software comprising or in any way making up a part of the
              Site.
            </p>
          </div>
          <div>
            4.7 - You may copy and store any Content without the express written
            permission of Trevex or the owners of the Content at your own risk.
            Any unauthorized use or reproduction of the Content is strictly
            prohibited and Trevex accepts no liability or responsibility for any
            unauthorised use of the Content.
          </div>
          <div>
            4.8 - Trevex is not responsible for any Content posted on the Site.
            Trevex endeavours to provide accurate and reliable information on the
            Site. However, Trevex does not provide any guarantees in relation to
            the correctness or accuracy of any information or Content on the Site,
            unless any information or Content is expressly stated by Trevex to be
            verified. Trevex may at its sole discretion verify the information
            provided by users of the Site and reserves the right to change or
            remove any Content as it sees fit. Trevex is under no obligation to
            verify the information and accepts no liability for any Content which
            is not expressly stated to be verified.
          </div>
          <div>
            4.9 - Trevex reserves the right to prevent or suspend your access to
            the Site if you do not comply with these Terms or any applicable law.
          </div>
        </div>
        <div className="my-5 flex text-start	 flex-col">
          <div className="font-bold text-[20px]">
            5 - Registration on the Site
          </div>
          <div>
            5.1 - You may access most areas of the Site without registering with
            us. Some areas of the Site may require registration, particularly in
            order to access enhanced features of the Site.
          </div>
          <div>
            5.2 - Each registration is for a single user only. Trevex does not
            permit you to share your login credentials with any other person and
            does not allow you to share your login credentials to be used with
            multiple users.
          </div>
          <div>
            5.3 - We are not obliged to permit anyone to register with the Site
            and we may refuse, terminate or suspend registration to anyone at any
            time.
          </div>
          <div>
            5.4 - You are responsible for making sure that your login credentials
            and any other account details are kept secure and confidential.
          </div>
          <div>
            5.5 - If we have reason to believe that there is likely to be a breach
            of security or misuse of the Site through your account or the use of
            your password, we may notify you and require you to change your
            password, or we may suspend or terminate your account.
          </div>
          <div>
            5.6 - Any personal information you provide to us as part of the
            registration process will be processed in accordance with our Privacy
            and Data Protection Policy.
          </div>
          <div>
            5.7 - Trevex shall not be liable for any inaccuracies,
            misrepresentations, errors or omissions in any information provided by
            the users of the Site upon or after registration or information which
            has been obtained through other means. Trevex shall not be liable for
            the accuracy or correctness of any information or Content which ceases
            to be accurate or correct as a result of any updates to the same or
            changes to the applicable law and/or regulations or any changes
            resulting from other means which may affect the accuracy and
            correctness of the information and Content of the Site.
          </div>
          <div>
            5.8 - By registering on the Site you shall be responsible to ensure
            that any information provided to the Site is true and accurate to the
            best of your knowledge, is not misleading and is not being used to
            commit any act of fraud.
          </div>
        </div>
        <div className="my-5 flex text-start	 flex-col">
          <div className="font-bold text-[20px]">6 - Payment</div>
          <div>
            6.1 - For services offered on a pay-as-you-go or subscription basis,
            these Terms apply unless Trevex notifies you in writing. These Terms
            will also apply to one-time payments for company profile registration
            & verification services.
          </div>
          <div>
            6.2 - Payments will be billed to you by Trevex and/or its vendor(s) in
            Arab Emirates Dirham (AED), or other currencies which may be made
            available (in addition to any and all applicable taxes, including
            without limitation VAT), and your account will be debited when you
            subscribe and provide your payment information, unless stated
            otherwise in the ordering or payment terms on the website for the
            services.
          </div>
          <div>
            6.3 - If your payment and registration information is not accurate,
            current, and complete and you do not notify us promptly when such
            information changes, we may suspend or terminate your account and
            refuse any use of the Services.
          </div>
          <div>
            6.4 - If you do not notify us of updates to your payment method (e.g.,
            credit card expiration date), to avoid interruption of your service,
            Trevex and/or its vendor(s) may contact your card provider to try to
            update your payment information, and you authorize us to continue
            billing your account with the updated information that we obtain.
          </div>
          <div>
            6.5 - Trevex will automatically renew your monthly, quarterly, or
            annual subscriptions at the current rates, unless the subscriptions
            are cancelled or terminated under this Agreement.
          </div>

          <div>
            6.6 - All authorized refunds will be made in the original form of
            payment to Trevex or its vendor(s).
          </div>
          <div>
            6.7 - Upon cancellation you will be able to access the Site with full
            functionality until the end of the subscription term. After the
            subscription term ends, you will have limited access to the Site and
            we take no responsibility for preservation of any data that might be
            lost due to the end of subscription. There are no refunds upon
            cancellation.
          </div>
        </div>
        <div className="my-5 flex text-start	 flex-col">
          <div className="font-bold text-[20px]">
            7 - Accessing information from the Site
          </div>
          <div>
            7.1 - Trevex owns and operates the Site on which we provide
            information relating to businesses. Trevex is not a commercial agent
            and does not endorse any of the businesses enlisted in its directory,
            which may be accessed by users of the Site, together with other
            content on the Site. Businesses who enlist with Trevex do so
            voluntarily and consent to the display of their information on the
            Site. Trevex excludes all liability for any communications between you
            and other users of the Site and does not participate in any
            transactions between users of the Site.
          </div>
          <div>
            7.2 - The business directory displayed on the Site is provided by
            Trevex in good faith and Trevex does not actively verify material
            submitted by users of the Site. You are responsible for making your
            own enquiries and Trevex provides no guarantee and accepts no
            responsibility for the accuracy or completeness of any information
            contained within the Site unless Content is expressly stated by Trevex
            to be verified.
          </div>
          <div>
            7.3 - Content posted on our Site is not intended to amount to advice
            on which reliance should be placed. We therefore disclaim all
            liability and responsibility arising from any reliance placed on such
            Content by any visitor to our site, or by anyone who may be informed
            of any of its Content.
          </div>
        </div>
        <div className="my-5 flex text-start	 flex-col">
          <div className="font-bold text-[20px]">
            8 - Submitting information to the Site
          </div>

          <div>8.1 - Users of the Site who submit information to the Site:</div>
          <p>
            (a) Hereby consent that any information provided to us shall be
            voluntarily provided by you to us and you further consent that by
            submitting information, you grant to us a royalty-free, irrevocable,
            non-exclusive, transferable licence to use, reproduce, modify,
            publish, edit, translate, distribute, perform, modify and display the
            information (in whole or in part) on the Site, and on any other
            websites operated by us, indefinitely, and we may use it for any
            purpose on an unrestricted and free-of-charge basis as we reasonably
            see fit;
          </p>
          <p>
            (b) warrant that they are the holder of the rights in the Content that
            they post and are authorised to make the Content available and have
            obtained all necessary licenses and approvals;
          </p>
          <p>
            (c) agree that any information given for the purpose of display is
            non-confidential and non-proprietary.
          </p>
          <p>
            (d) ensure that no other person, authorised or otherwise makes use of
            their access to the Site in breach of these Terms;
          </p>
          <p>
            (e) ensure that the Content they post is not unlawful or posted for an
            improper purpose, including information that is defamatory, misleading
            or deceptive, obscene, indecent, seditious, offensive, pornographic,
            abusive, liable to incite racial hatred, discriminatory, menacing,
            scandalous, inflammatory, blasphemous, in breach of confidence, in
            breach of privacy or which may cause annoyance or inconvenience, or in
            breach of copyright or which would otherwise expose Trevex to any
            liability, legal proceedings or other sanctions;
          </p>
          <p>
            (f) acknowledge that Trevex is under no obligation to monitor or
            censor the material that appears on the Site (whether generated by you
            or others), however Trevex reserves the right to do so and may
            penalise Content which it deems unfit;
          </p>
          <p>
            (g) acknowledge the disclaimers and limitation of liability contained
            in these Terms;
          </p>
          <p>
            (h) acknowledge that they are responsible for the security and
            integrity of their data and that Trevex is not responsible for any
            errors or omissions in any Content that they provide or that is
            provided on their behalf;
          </p>
          <p>
            (i) warrant that they will comply with all applicable laws, rules and
            regulations; and
          </p>
          <p>
            (j) agree to comply with all reasonable instructions of Trevex and all
            relevant laws in relation to their use of the Site.
          </p>
        </div>
        <div className="my-5 flex text-start	 flex-col">
          <div className="font-bold text-[20px]">9 - Privacy </div>
          <div>
            Your privacy and personal information are important to us. Any
            personal information that you provide to us will be dealt with in line
            with our Privacy and Data Protection Policy, which explains what
            personal information we collect from you, how and why we collect,
            store, use and share such information, your rights in relation to your
            personal information and how to contact us and supervisory authorities
            in the event you have a query or complaint about the use of your
            personal information.
          </div>
        </div>
        <div className="my-5 flex text-start	 flex-col">
          <div className="font-bold text-[20px]">10 - Intellectual Property</div>
          <div>
            10.1 - The intellectual property rights in the Site and in any text,
            images, video, audio or other multimedia content, software or other
            information or material submitted to or accessible from the Site are
            owned by us and our licensors.
          </div>
          <div>
            10.2 - We and our licensors reserve all our intellectual property
            rights (including, but not limited to, all copyright, trade marks,
            domain names, design rights, database rights, patents and all other
            intellectual property rights of any kind) whether registered or
            unregistered anywhere in the world. Trevex remains owners of them and
            are free to use them as we see fit
          </div>
          <div>
            10.3 - Nothing in these Terms grants you any legal rights in the Site
            or the Content other than as necessary for you to access it. You agree
            not to adjust, try to circumvent or delete any notices contained on
            the Site or the Content (including any intellectual property notices)
            and in particular, in any digital rights or other security technology
            embedded or contained within the Site or the Content.
          </div>
          <div>
            10.4 - Trademarks of Trevex are our trademarks which may be used on
            the Site or in the Content and any third party trademarks used on the
            Site belong to their respective owners. Other trademarks and trade
            names may also be used on the Site or in the Content. Use by you of
            any trademarks on the Site or in the Content is strictly prohibited
            unless you have our prior written permission.
          </div>
          <div>
            10.5 - We will use reasonable efforts to delete accounts which are
            being used in an inappropriate manner or in breach of these Terms; and
            identify and remove any content that is inappropriate, defamatory,
            infringes intellectual property rights or is otherwise in breach of
            our Terms.
          </div>
        </div>
        <div className="my-5 flex text-start	 flex-col">
          <div className="font-bold text-[20px]">
            11 - Hyperlinks and third party sites
          </div>
          <div>
            The Site may contain hyperlinks or references to third party
            advertising and websites other than the Site. Any such hyperlinks or
            references are provided for your convenience only. We have no control
            over third party advertising or websites and accept no legal
            responsibility for any content, material or information contained in
            them. The display of any hyperlink and reference to any third party
            advertising or website does not mean that we endorse that third
            party’s website, products or services. Your use of a third party site
            may be governed by the terms and conditions of that third-party site
            and is at your own risk.
          </div>
        </div>
        <div className="my-5 flex text-start	 flex-col">
          <div className="font-bold text-[20px]">12 - Links to the Site</div>
          <div>
            <div>
              12.1 - You may create a link to our Site from another website
              without our prior written consent provided no such link:
            </div>
            <p>
              (a) creates a frame or any other browser or border environment
              around the content of our Site;
            </p>
            <p>
              (b) implies that we endorse your products or services or any of the
              products or services of, or available through, the website on which
              you place a link to our Site;
            </p>
            <p>
              (c) displays any of the trade marks or logos used on our Site
              without our permission or that of the owner of such trade marks or
              logos; or
            </p>
            <p>(d) is placed on a website that itself breaches these Terms.</p>
            <div>
              12.2 - We reserve the right to require you to immediately remove any
              link to the Site at any time, and you shall immediately comply with
              any request by us to remove any such link.
            </div>
          </div>
        </div>
        <div className="my-5 flex text-start	 flex-col">
          <div className="font-bold text-[20px]">
            13 - Disclaimers of Warranties and Limitation of Liability
          </div>
          <div>
            13.1 - The Site is provided for information purposes only and should
            not be used as a basis for entering into agreements or for making
            business decisions and should not be considered as a substitute for
            specific professional advice. Trevex makes no warranties or
            representations to you as to the accuracy, authenticity or
            completeness of the Content on the Site, which is subject to change at
            any time without notice.
          </div>
          <div>
            13.2 - The Site and Content are provided on an 'AS-IS', “without
            faults” and “as available” basis and, to the extent lawful, with no
            warranties whatsoever. Trevex expressly disclaims (to the fullest
            extent permitted by law) any and all express, implied, and statutory
            warranties, including, without limitation, the warranties of
            merchantability, fitness for a particular purpose, freedom from
            computer virus, title, and non-infringement of proprietary rights.
          </div>
          <div>
            13.3 - Trevex and its personnel are not liable for any direct,
            indirect, punitive, incidental, special, or consequential damages or
            loss (including, without limitation, incidental and consequential
            damages, lost profits, or damages resulting from lost data or business
            interruption) arising out of, or in any way connected with, the use or
            inability to use the Site and/or Content, whether based on warranty,
            contract, tort (including negligence), or any other legal theory, and
            whether or not Trevex is advised of the possibility of such damages.
            Trevex does not accept any liability in respect of your involvement in
            any mediation, arbitration, tribunal hearing, court proceeding or
            other proceedings (of whatever nature) with any third party in any
            way.
          </div>
          <div>
            13.4 - Trevex does not warrant that the Site or Content shall be free
            of technical, typographical or photographic errors. Trevex does not
            represent, warrant or endorse that any of the Content is accurate,
            complete, reliable or current. Trevex may make changes to the
            materials contained on the Site at any time without notice. You
            acknowledge that any reliance upon the Site shall be at your sole
            risk.
          </div>
          <div>
            13.5 - Trevex is not responsible for any problems or technical
            malfunction of any telephone network or lines, computer online
            systems, servers or providers, computer equipment, software, failure
            of any email due to technical problems or traffic congestion on the
            Internet or on the Site, including any injury or damage to any users
            or to any person's computer related to or resulting from participation
            or downloading materials in connection with the Site.
          </div>
          <div>
            13.6 - Reference to any specific commercial product, process, or
            service by trade name, trademark, manufacturer, or otherwise does not
            constitute or imply its endorsement, recommendation, or favouring by
            Trevex. The views and opinions of document authors do not necessarily
            state or reflect those of Trevex.
          </div>
          <div>
            <div>
              13.7 - Nothing in this legal notice shall exclude or limit the
              Company's liability for:{" "}
            </div>
            <p>
              (a) death or personal injury caused by negligence under the
              applicable law; or
            </p>
            <p>(b) fraud; or</p>
            <p>(c) misrepresentation as to a fundamental matter; or </p>
            <p>
              (d) any liability which cannot be excluded or limited under
              applicable law.
            </p>
          </div>
        </div>
        <div className="my-5 flex text-start	 flex-col">
          <div className="font-bold text-[20px]">14 - Indemnification</div>
          <div>
            14.1 - You agree to indemnify, defend and hold Trevex harmless from
            and against any and all claims, liability, suits, judgments,
            litigation costs, causes of action, demands, recoveries, damages
            (actual and consequential), fines, penalties, losses, costs and
            expenses (including attorneys’ fees) of any kind or nature incurred by
            Trevex arising from or in any way related to: your use of this Site
            (including, by third parties); your breach of these Terms or any other
            terms referenced herein your violation of any law or the rights of a
            third party.
          </div>
        </div>
        <div className="my-5 flex text-start	 flex-col">
          <div className="font-bold text-[20px]">15 - Force-majeure</div>
          <div>
            We are not liable to you if we fail to comply with these Terms because
            of circumstances beyond our reasonable control, including, but not
            limited to, strikes, lock-outs or other industrial disputes; breakdown
            of systems or network access; flood, fire, explosion or accident; or
            epidemics or pandemics.
          </div>
        </div>
        <div className="my-5 flex text-start	 flex-col">
          <div className="font-bold text-[20px]">
            16 - Rights of third parties
          </div>
          <div>
            No one other than a party to these Terms has any right to enforce any
            of these Terms.
          </div>
        </div>
        <div className="my-5 flex text-start	 flex-col">
          <div className="font-bold text-[20px]">17 - Variation</div>
          <div>
            17.1 - No changes to these Terms are valid or have any effect unless
            agreed by us in writing or made in accordance with this clause.
          </div>
          <div>
            17.2 - We reserve the right to vary these Terms from time to time. Our
            updated Terms will be displayed on the Site and by continuing to use
            and access the Site following such changes, you agree to be bound by
            any variation made by us. It is your responsibility to check these
            Terms from time to time to verify such variations.
          </div>
        </div>
        <div className="my-5 flex text-start	 flex-col">
          <div className="font-bold text-[20px]">18 - Termination of Service</div>
          <div>
            Trevex reserves the right, in its sole discretion, to restrict,
            suspend or terminate your access to all or any part of the Site at any
            time for any reason without prior notice or liability. Trevex may
            change, suspend or discontinue all or any aspect of the Site at any
            time, including the availability of any feature, database, Content
            without prior notice or liability. Except as otherwise expressly
            stated in these Terms, Trevex shall not be liable to you or to any
            third party for any modification, termination, suspension or
            discontinuation of the Site.
          </div>
        </div>
        <div className="my-5 flex text-start	 flex-col">
          <div className="font-bold text-[20px]">19 - Breach</div>
          <div>
            We shall apply these Terms in our absolute discretion. In the event of
            your breach of these Terms we may terminate or suspend your use of the
            Site, remove or edit submissions, disclose submissions or any other
            communication to users of our Site by you to law enforcement
            authorities or take any action we consider necessary to remedy the
            breach.
          </div>
        </div>
        <div className="my-5 flex text-start	 flex-col">
          <div className="font-bold text-[20px]">20 - Disputes</div>
          <div>
            20.1 - We will try to resolve any disputes with you quickly and
            efficiently. If you are unhappy with us, please contact us as soon as
            possible using the contact details set out above.
          </div>
          <div>
            20.2 - If a dispute cannot be resolved using our complaint handling
            procedure or you are unhappy with the outcome, you may bring court
            proceedings.
          </div>
          <div>
            20.3 - These Terms as well as your access to the Site is subject to
            and governed by the laws of the Dubai International Financial Centre
            in the Emirate of Dubai without giving effect to conflicts of law
            principles thereof. Any dispute regarding these Terms or our use of
            the Site is subject to the exclusive jurisdiction of the DIFC{" "}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}


